import GlobalNav from './global-nav.vue';
import CupLogo from '../components/icon/cup-logo.vue';
import { customEventTrigger } from '../lib/customGoogleEvents';
export default {
  components: {
    GlobalNav,
    CupLogo
  },
  props: {
    showDiscoveryTool: {
      type: Boolean,
      default: true
    },
    environment: {
      type: String,
      default: 'PROD'
    }
  },
  mounted() {
    this.$refs.globalHeaderContainer.addEventListener('click', this.click);
  },
  unmounted() {
    this.$refs.globalHeaderContainer.removeEventListener('click', this.click);
  },
  methods: {
    click(e) {
      customEventTrigger(e);
    }
  }
};